import configdata from "../../config.json";
import { qualitySliceAction } from "./QualitySlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllQualityItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi("get", `${configdata.SERVER_URL}/api/qualities`);
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(qualitySliceAction.getAllQuality(res.data.quality));
  };
};
export const createQualityItem = (data) => {
  return async (dispatch) => {
    const { form } = getOnlyValueFromSelectObject(data);
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/qualities/store`,
      form
    );
    if (res?.error) {
      if (res?.erroType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: res.message, isError: true })
        );
      } else {
        dispatch(
          qualitySliceAction.setErrorData({
            message: res.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      qualitySliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(qualitySliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllQualityItems());
  };
};
export const getDataForEdit = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/qualities/edit/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.quality[0] };

    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    dispatch(qualitySliceAction.getQualityDataEdit(data));
  };
};

export const updateQualityItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/qualities/update/${data.id}`,
      form
    );
    if (res?.error) {
      if (res?.erroType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: res.message, isError: true })
        );
      } else {
        dispatch(
          qualitySliceAction.setErrorData({
            message: res.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      qualitySliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(qualitySliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllQualityItems());
  };
};

export const deleteQualityItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi("get", `${configdata.SERVER_URL}/api/qualities/delete/${id}`);
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
